
import React from 'react'

export const Title = props =>{
    return(
        <h2>{props.children}</h2>
    )
}

export const Dates = props => {
    return(
        <h4>{props.children}</h4>
    )
}

export const Locations = props => {
    return(
        <h5>{props.children}</h5>

    )
}

export const Description = props => {
    return(
        <p>{props.children}</p>
    )
}

export const Link = props => {
    return(
        <p><a href={props.src}>{props.children}</a></p>
    )
}

export const Image = props => {
    return(
        <div className="image">
                
                <img src={props.children} />
        </div>
    )
}

const Entry = props => {
    const material = props.children
    return (
        <li className="entry">
            <Image>{props.src}</Image>
            {material}  
        </li>
    )
}

export default Entry
